export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export const faqItems: FAQItem[] = [
  {
    id: "faq-1",
    question: "世界杯门票多少钱一张？",
    answer: "世界杯门票价格因比赛阶段和座位等级而异。小组赛Cat 3门票起价较低，随着比赛进入淘汰赛阶段价格逐步提高。决赛门票价格最高，通常达到数百至上千美元。具体价格请以FIFA官方公布的售票信息为准。",
    category: "价格相关"
  },
  {
    id: "faq-2",
    question: "一个人最多能买几张世界杯门票？",
    answer: "在FIFA官方售票中，每位注册用户最多可以为包括自己在内的4人申请同一场比赛的门票。在随机抽签阶段，你可以对多场比赛提交申请。具体限制请参考当届世界杯的售票规则。",
    category: "购票规则"
  },
  {
    id: "faq-3",
    question: "没有中签怎么办？还有其他购票途径吗？",
    answer: "如果首轮抽签没有中签，你还有以下机会：参加第二轮先到先得销售、通过FIFA官方转售平台购买回流门票、联系官方授权代理商购买套餐。建议多渠道同时准备，提高成功率。",
    category: "购票规则"
  },
  {
    id: "faq-4",
    question: "如何验证世界杯门票的真伪？",
    answer: "最可靠的方式是通过FIFA官方App扫描门票上的二维码进行验证。世界杯电子门票采用动态加密技术，每张门票都有唯一识别码。你也可以通过门票上的全息防伪标签和序列号进行初步判断。",
    category: "安全相关"
  },
  {
    id: "faq-5",
    question: "可以在二手平台（如闲鱼、淘宝）购买世界杯门票吗？",
    answer: "强烈建议不要在非官方二手平台购买世界杯门票。这些平台的卖家通常不是授权渠道，门票真伪无法保障。FIFA官方转售平台是唯一合法的二手门票交易渠道。从非官方渠道购票，一旦发现使用假票，不仅无法入场，还可能面临法律风险。",
    category: "安全相关"
  },
  {
    id: "faq-6",
    question: "儿童需要单独购买门票吗？",
    answer: "是的，世界杯比赛通常要求所有入场观众（包括婴幼儿）均需持有有效门票。部分场次可能提供儿童优惠票，但需以当届世界杯的具体政策为准。建议提前查阅FIFA官方售票规则中的年龄限制说明。",
    category: "购票规则"
  },
  {
    id: "faq-7",
    question: "购票后可以退款或转让吗？",
    answer: "FIFA官方售票通常有严格的退改政策。在随机抽签阶段中签后，如果在规定时间内未完成支付，门票将被自动释放。已完成支付的门票如需转让，只能通过FIFA官方转售平台按原价转售。不同授权代理商的退改政策可能有所不同，购票前请仔细阅读相关条款。",
    category: "购票规则"
  },
  {
    id: "faq-8",
    question: "中国队进入世界杯的话，中国球迷购票有特殊渠道吗？",
    answer: "如果中国队晋级世界杯，FIFA通常会为中国足协分配一定比例的门票配额，这些门票将通过中国足协或其指定的渠道向中国球迷销售。关注中国足协官方公告，获取最新购票信息。同时，你也可以申请团队特定门票（TST），跟随中国队的所有比赛。",
    category: "特殊渠道"
  },
  {
    id: "faq-9",
    question: "世界杯电子门票如何使用？",
    answer: "世界杯采取电子门票（Mobile Ticket）形式。你需要下载FIFA官方App，使用购票账号登录后即可查看并激活门票。比赛当天，打开App展示动态二维码，在球场入口处扫码入场。建议提前截图保存门票，以防现场网络信号不稳定。",
    category: "使用指南"
  },
  {
    id: "faq-10",
    question: "如何选择观赛座位？哪个位置观看体验最好？",
    answer: "最佳观赛位置通常位于球场中线两侧的看台区域（Cat 1区域），可以全视角观看比赛。球门后方看台（Cat 3区域）价格较低，但视角受限。如果你关注某支特定球队，可以关注该队球迷区的座位分配。选择时建议参考球场座位图和过往球迷的观赛体验分享。",
    category: "使用指南"
  }
];